import BookItem from "../common/bookItem";
import VisibleSwitchAnsStepPicChild from "../visibleswitchans_step/visible_switch_ans_step_pic_child";
export default class VisibleSwitchAnsStepAll extends BookItem {
    constructor(el, target) {
        super(el, target);
        this.el = el;
        this.ctrlOrder = 0;
        this.connectNumber = this.el.connectNumber;

        /**
         * 上一步按鈕
         */
        this.storeUp = null;

        /**
         * 下一步按鈕
         */
        this.storeDown = null;

        /**
         * 子物件
         */
        this.childObj = null;

        /**
         * 子物件連續圖
         */
        this.rowPicObj = [];

        this.add_mouse_event();

        this.target.gotoAndStop(0);
    }

    init() {

        /**
         * 暫存getItemsByClassConnect的陣列後續使用
         */
        let tempChildObj = [];
        // 抓Connect子物件
        tempChildObj = this.itemControl.getItemsByClassConnect("stepbtnchild", this);
        if (tempChildObj.length == 1) {
            this.childObj = tempChildObj[0];
        }
        else {
            console.warn("此編號逐步解答子物件頁面上不是1個");
        }

        this.rowPicObj = this.itemControl.getItemsByClassConnect("stepbtnpicchild", this);

        // 抓Connect上下步按鈕子物件
        this.childGroup = this.itemControl.getItemsByClassConnect("stepbtn", this);
        // Connect子物件紀錄主按鈕、紀錄子按鈕
        this.childGroup.forEach(element => {
            // Connect子物件紀錄主按鈕
            element.mainGroup.push(this);

            // Connect子物件紀錄子按鈕
            element.childObj = this.childObj;

            //  Connect子物件紀錄連續圖
            if (this.rowPicObj != undefined) {
                this.rowPicObj.forEach(obj => {
                    element.rowPicObj.push(obj);
                });
            }

            if (element.ctrlObjStep == "上一個") {
                this.storeUp = element;
            }
            else if (element.ctrlObjStep == "下一個") {
                this.storeDown = element;
            }
        });


    }

    /**
     * 處理主按鈕
     */
    ProcessMainBtn() {
        if (this.isOpen == false) {
            // 現在狀態是要關所以開到第一影格
            // console.log("this.target.gotoAndStop(0)")
            this.target.gotoAndStop(0);
        }
        else {
            // 現在狀態是要開所以開到最後一影格
            // console.log("this.target.gotoAndStop(1)")
            this.target.gotoAndStop(1);
        }
    }

    /**
     * 處理子按鈕
     */
    ProcessChildBtn() {
        if (this.isOpen == false) {
            // 現在狀態是要關所以開到第一格
            this.childObj.isOpen = false;
            this.childObj.target.gotoAndStop(0);

            this.storeUp.target.gotoAndStop(2);
            this.storeUp.target.mouseEnabled = false;

            this.storeDown.target.gotoAndStop(0);
            this.storeDown.target.mouseEnabled = true;


            if (this.rowPicObj != undefined) {
                this.rowPicObj.forEach(element => {
                    element.target.visible = false;
                    element.target.gotoAndStop(0);
                    element.itemControl.loader.singleAntialiasing(element.target);
                });
            }
            // console.log("現在是全開狀態(end)所以全關(0)");
        }
        else {
            // 現在狀態是要開所以開到最後一格
            this.childObj.isOpen = true;
            this.childObj.target.gotoAndStop(this.childObj.target.totalFrames - 1);

            this.storeUp.target.gotoAndStop(0);
            this.storeUp.target.mouseEnabled = true;

            this.storeDown.target.gotoAndStop(2);
            this.storeDown.target.mouseEnabled = false;

            if (this.rowPicObj != undefined) {
            this.rowPicObj.forEach(element => {
                element.target.visible = true;
                element.target.gotoAndStop(element.target.totalFrames - 1);
                element.itemControl.loader.singleAntialiasing(element.target);
            });
            }
            // console.log("現在是非全開狀態(x0)所以全開(end)");
        }
    }

    trigger() {
        const self = this;
        self.isOpen = !self.isOpen;
        this.ProcessMainBtn();
        this.ProcessChildBtn();
    }

    ControlTrigger(state) {
        const self = this;
        self.isOpen = state;
        this.ProcessMainBtn();
        this.ProcessChildBtn();
    }

    add_mouse_event() {
        this.target.mouseChildren = false;
        this.target.removeAllEventListeners();
        this.target.addEventListener("click", () => {
            this.trigger();
            this.itemControl.loader.singleAntialiasing(this.target);
        });
    }

    /**
     * 主按鈕檢查群子按鈕
     */
    TestCheck() {
        if (this.childObj.target.currentFrame != this.childObj.target.totalFrames - 1) {
            // 現在子物件顯示不在最後一格所以是關閉狀態，主物件開到第一格影格
            // console.log("this.target.gotoAndStop(0)")
            this.target.gotoAndStop(0);
            this.isOpen = false;
        }
        else {
            // 現在子物件顯示在最後一格所以是打開狀態，主物件開到最後一格影格
            // console.log("this.target.gotoAndStop(1)")
            this.target.gotoAndStop(1);
            this.isOpen = true;
        }
    }
}